"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnauthorisedError = exports.SessionExpiredError = exports.ServiceNotAvailableError = exports.SendEmailError = exports.ResourceNotFoundError = exports.RequestError = exports.QuoteValidationError = exports.QuoteSubmittedError = exports.QuoteRetrieveError = exports.QuoteInvalidError = exports.QuoteError = exports.PageNotFoundError = exports.NavigateWhileExecutingActionError = exports.IpDeniedError = exports.InternalServerError = exports.BadRequestError = void 0;
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
/* eslint-disable max-classes-per-file */
var QuoteError = exports.QuoteError = /*#__PURE__*/function (_Error) {
  _inherits(QuoteError, _Error);
  var _super = _createSuper(QuoteError);
  function QuoteError(params) {
    var _this;
    _classCallCheck(this, QuoteError);
    _this = _super.call(this, params);
    _this.name = 'QuoteError';
    _this.title = 'Invalid Quote Data';
    _this.message = 'Quote is not valid, please try a new quote';
    return _this;
  }
  return _createClass(QuoteError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var QuoteInvalidError = exports.QuoteInvalidError = /*#__PURE__*/function (_Error2) {
  _inherits(QuoteInvalidError, _Error2);
  var _super2 = _createSuper(QuoteInvalidError);
  function QuoteInvalidError(params) {
    var _this2;
    _classCallCheck(this, QuoteInvalidError);
    _this2 = _super2.call(this, params);
    _this2.name = 'QuoteInvalidError';
    _this2.title = 'Invalid Quote Data';
    _this2.message = 'Quote is not valid, please try a new quote';
    return _this2;
  }
  return _createClass(QuoteInvalidError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var QuoteSubmittedError = exports.QuoteSubmittedError = /*#__PURE__*/function (_Error3) {
  _inherits(QuoteSubmittedError, _Error3);
  var _super3 = _createSuper(QuoteSubmittedError);
  function QuoteSubmittedError(params) {
    var _this3;
    _classCallCheck(this, QuoteSubmittedError);
    _this3 = _super3.call(this, params);
    _this3.name = 'QuoteSubmittedError';
    _this3.title = 'Application Submitted';
    _this3.message = 'The application has been submitted, please try a new quote.';
    return _this3;
  }
  return _createClass(QuoteSubmittedError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var QuoteRetrieveError = exports.QuoteRetrieveError = /*#__PURE__*/function (_Error4) {
  _inherits(QuoteRetrieveError, _Error4);
  var _super4 = _createSuper(QuoteRetrieveError);
  function QuoteRetrieveError(params) {
    var _this4;
    _classCallCheck(this, QuoteRetrieveError);
    _this4 = _super4.call(this, params);
    _this4.name = 'QuoteRetrieveError';
    _this4.title = 'Quote Unretrievable';
    _this4.message = 'Your quote has been expired or is invalid.';
    return _this4;
  }
  return _createClass(QuoteRetrieveError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var SessionExpiredError = exports.SessionExpiredError = /*#__PURE__*/function (_Error5) {
  _inherits(SessionExpiredError, _Error5);
  var _super5 = _createSuper(SessionExpiredError);
  function SessionExpiredError(params) {
    var _this5;
    _classCallCheck(this, SessionExpiredError);
    _this5 = _super5.call(this, params);
    _this5.name = 'SessionExpiredError';
    _this5.title = 'System Message';
    _this5.message = 'Your session has been expired, please start a new quote.';
    return _this5;
  }
  return _createClass(SessionExpiredError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var PageNotFoundError = exports.PageNotFoundError = /*#__PURE__*/function (_Error6) {
  _inherits(PageNotFoundError, _Error6);
  var _super6 = _createSuper(PageNotFoundError);
  function PageNotFoundError(params) {
    var _this6;
    _classCallCheck(this, PageNotFoundError);
    _this6 = _super6.call(this, params);
    _this6.name = 'NotFoundError';
    _this6.title = '404 page error';
    _this6.message = 'Opps! The page cannot be found.';
    return _this6;
  }
  return _createClass(PageNotFoundError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var IpDeniedError = exports.IpDeniedError = /*#__PURE__*/function (_Error7) {
  _inherits(IpDeniedError, _Error7);
  var _super7 = _createSuper(IpDeniedError);
  function IpDeniedError(params) {
    var _this7;
    _classCallCheck(this, IpDeniedError);
    _this7 = _super7.call(this, params);
    _this7.name = 'IpDeniedError';
    _this7.title = 'IP Restriction';
    _this7.message = 'Access Deny. Please try again later.';
    return _this7;
  }
  return _createClass(IpDeniedError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var ServiceNotAvailableError = exports.ServiceNotAvailableError = /*#__PURE__*/function (_Error8) {
  _inherits(ServiceNotAvailableError, _Error8);
  var _super8 = _createSuper(ServiceNotAvailableError);
  function ServiceNotAvailableError(params) {
    var _this8;
    _classCallCheck(this, ServiceNotAvailableError);
    _this8 = _super8.call(this, params);
    _this8.name = 'ServiceNotAvailableError';
    _this8.title = 'Service is not available';
    _this8.message = 'Service is not available, please try again later.';
    return _this8;
  }
  return _createClass(ServiceNotAvailableError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var UnauthorisedError = exports.UnauthorisedError = /*#__PURE__*/function (_Error9) {
  _inherits(UnauthorisedError, _Error9);
  var _super9 = _createSuper(UnauthorisedError);
  function UnauthorisedError(params) {
    var _this9;
    _classCallCheck(this, UnauthorisedError);
    _this9 = _super9.call(this, params);
    _this9.name = 'Unauthorised';
    _this9.title = 'Unauthorised';
    _this9.message = 'The resource you are trying to access is unauthorized';
    return _this9;
  }
  return _createClass(UnauthorisedError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var QuoteValidationError = exports.QuoteValidationError = /*#__PURE__*/function (_Error10) {
  _inherits(QuoteValidationError, _Error10);
  var _super10 = _createSuper(QuoteValidationError);
  function QuoteValidationError(params) {
    var _this10;
    _classCallCheck(this, QuoteValidationError);
    _this10 = _super10.call(this, params);
    _this10.name = 'QuoteValidationError';
    _this10.title = 'Quote Validation';
    _this10.message = 'Quote is not valid, please try a new quote';
    return _this10;
  }
  return _createClass(QuoteValidationError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var RequestError = exports.RequestError = /*#__PURE__*/function (_Error11) {
  _inherits(RequestError, _Error11);
  var _super11 = _createSuper(RequestError);
  function RequestError(params) {
    var _this11;
    _classCallCheck(this, RequestError);
    _this11 = _super11.call(this, params);
    _this11.name = 'RequestError';
    _this11.title = 'Request Error';
    _this11.message = '';
    return _this11;
  }
  return _createClass(RequestError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var ResourceNotFoundError = exports.ResourceNotFoundError = /*#__PURE__*/function (_Error12) {
  _inherits(ResourceNotFoundError, _Error12);
  var _super12 = _createSuper(ResourceNotFoundError);
  function ResourceNotFoundError(params) {
    var _this12;
    _classCallCheck(this, ResourceNotFoundError);
    _this12 = _super12.call(this, params);
    _this12.name = 'ResourceNotFoundError';
    _this12.title = 'Resource Not Found';
    _this12.message = 'The resource you are trying to access is not found';
    return _this12;
  }
  return _createClass(ResourceNotFoundError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var BadRequestError = exports.BadRequestError = /*#__PURE__*/function (_Error13) {
  _inherits(BadRequestError, _Error13);
  var _super13 = _createSuper(BadRequestError);
  function BadRequestError(params) {
    var _this13;
    _classCallCheck(this, BadRequestError);
    _this13 = _super13.call(this, params);
    _this13.name = 'BadRequestError';
    _this13.title = 'Bad Request';
    _this13.message = 'Oops, something went wrong';
    return _this13;
  }
  return _createClass(BadRequestError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var InternalServerError = exports.InternalServerError = /*#__PURE__*/function (_Error14) {
  _inherits(InternalServerError, _Error14);
  var _super14 = _createSuper(InternalServerError);
  function InternalServerError(params) {
    var _this14;
    _classCallCheck(this, InternalServerError);
    _this14 = _super14.call(this, params);
    _this14.name = 'InternalServerError';
    _this14.title = 'Internal Server';
    _this14.message = 'Oops, something went wrong';
    return _this14;
  }
  return _createClass(InternalServerError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var SendEmailError = exports.SendEmailError = /*#__PURE__*/function (_Error15) {
  _inherits(SendEmailError, _Error15);
  var _super15 = _createSuper(SendEmailError);
  function SendEmailError(params) {
    var _this15;
    _classCallCheck(this, SendEmailError);
    _this15 = _super15.call(this, params);
    _this15.name = 'SendEmailError';
    _this15.title = 'Send Email Error';
    _this15.message = 'There is unexpected error when sending the email.';
    return _this15;
  }
  return _createClass(SendEmailError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var NavigateWhileExecutingActionError = exports.NavigateWhileExecutingActionError = /*#__PURE__*/function (_Error16) {
  _inherits(NavigateWhileExecutingActionError, _Error16);
  var _super16 = _createSuper(NavigateWhileExecutingActionError);
  function NavigateWhileExecutingActionError(params) {
    var _this16;
    _classCallCheck(this, NavigateWhileExecutingActionError);
    _this16 = _super16.call(this, params);
    _this16.name = 'NavigateWhileActionExecutingError';
    _this16.title = 'Navigation While Executing Action';
    _this16.message = 'User performs navigation while operation is executing';
    return _this16;
  }
  return _createClass(NavigateWhileExecutingActionError);
}( /*#__PURE__*/_wrapNativeSuper(Error));